



































import { format } from 'date-fns'
import Component from 'vue-class-component';
import { coreKaizen } from '@/common/coreKaizen'
import { ticketLogModel } from '@/models/kaizen/ticketLogModel';
import { Prop } from 'vue-property-decorator';

@Component
export default class timeline extends coreKaizen {
    @Prop(Number) ticket!: number
    @Prop(Array) ticketLog!: ticketLogModel[]

    dateFormat(value: Date): string {
        return format(value, 'DD-MM-YYYY hh:mm:ss aa')
    }
}
